define([
    'jQuery',
    'library/fcse-events/eventDispatcher'
],
    function($, EventDispatcher) {
        /**
         * Visiblity Controll
         *
         * @param selector
         * @constructor
         */
        var VisibilityControl = function (selector, options) {
            EventDispatcher.apply(this, arguments);
            //Set elements
            this._elements = $(selector);

            //Set options
            var defaultOptions = {
                // The attribute for the target selector of the element
                'targetSelectorAttribute': 'data-target',

                // The class name that the caller element (button) has when target is hidden
                'elementTargetIsHiddenClass': 'is-targethidden',

                // THe class name that caller element has when target is visible
                'elementTargetIsVisibleClass': 'is-targetvisible',

                // Class name of target when hidden
                'targetIsHiddenClass': 'is-hidden',

                // Class name of target when visible
                'targetIsVisibleClass': 'is-visible',

                // Animation duration in ms or jQuery animation speed keyword
                'animationDuration': 'fast',

                // If set to true, the labels will be exchanged
                'exchangeLabel': false,

                // Exchange label selector
                'exchangeLabelSelector': '[data-label-visible]',

                // True if we should see only one element under visibility control at a single moment of time
                'showSingleElement': false,

                // Defines group behavior. Useful for display flyouts simultaneously
                'groupExclude': true 
            };
            this.addOptions(defaultOptions, options);

            this.registerEvent('close');
            this.registerEvent('open');
            this.registerEvent('beforeOpen');

            this._initListeners();
        };

        VisibilityControl.prototype = $.extend(Object.create(EventDispatcher.prototype), {
            /**
             * Initializes listeners
             * @returns {undefined}
             */
            _initListeners: function(){
                this._elements.on('click', $.proxy(this._onElementClick, this));
            },

            /**
             * Element click handler
             * @param {type} event
             * @returns {undefined}
             */
            _onElementClick: function(event){
                var $element = $(event.currentTarget);

                var $target = $($element.attr(this.option('targetSelectorAttribute')));

                // Stop propagation if oustideclick close is enabled to prevent immediate close
                if ($element.attr('data-outsideclick-close') == '1'){
                    event.stopPropagation();
                }

                this.toggleTarget($element, $target);
            },

            /**
             * When destroying the component
             * @returns {undefined}
             */
            destroy: function(){
                this._elements.on('click', $.proxy(this._onElementClick, this));
            },

            /**
             * Toggle visibility of target
             * @param {type} element
             * @param {type} target
             * @returns {undefined}
             */
            toggleTarget: function(element, target){
                if (target.hasClass(this.option('targetIsHiddenClass'))){
                    this.openTarget(element, target);
                } else {
                    this.closeTarget(element, target);
                }
            },

            /**
             * Open target
             * @param {type} element
             * @param {type} target
             * @returns {undefined}
             */
            openTarget: function(element, target){
                var self = this;

                if (this.option('showSingleElement')) {
                    $(this._elements).each(function(idx, elem) {
                        var $elem = $(elem);
                        var shouldNotHide = $elem.attr('data-group') === $(element).attr('data-group');
                        if (self.option('groupExclude')) {
                            shouldNotHide = !shouldNotHide;
                        }
                        if ($(element).attr('data-group') && shouldNotHide) {
                            return;
                        }
                        $elem.addClass(self.option('elementTargetIsHiddenClass'));
                        $($elem.attr('data-target')).addClass(self.option('targetIsHiddenClass'));
                    });
                }

                // Fire up beforeOpen hook
                this.dispatchEvent('beforeOpen', element, target);

                //Show target
                $(target).addClass(this.option('targetIsVisibleClass'));
                $(target).removeClass(this.option('targetIsHiddenClass'));

                //Change classes on caller element
                $(element).removeClass(this.option('elementTargetIsHiddenClass'));
                $(element).addClass(this.option('elementTargetIsVisibleClass'));

                //Change labels on caller element if enabled
                if (this.option('exchangeLabel')){
                    $(this.option('exchangeLabelSelector'), element).each(function(index, labelElement){
                        $(labelElement).text($(labelElement).attr('data-label-visible'));
                    });
                }

                //Attach close handler on outside click (for tooltips, flyouts etc.)
                if ($(element).attr('data-outsideclick-close') == '1'){
                    $('html').on('click', $.proxy(this.closeTarget, this, element, target));
                    $(target).on('click', this._stopEventPropagation);

                }

                //Attach close handler on closebutton elements
                $('[data-fcse-role="visibilitycontrol--closebutton"]', target).on('click',
                    $.proxy(this.closeTarget, this, element, target));

                //Animate target
                var effect = $(target).attr('data-show-effect');
                switch (effect){
                    case 'fade': {
                        $(target).hide().fadeIn(this.option('animationDuration'));
                        break;
                    }
                    case 'slide': {
                        $(target).hide().slideDown(this.option('animationDuration'));
                        break;
                    }
                    case 'slidefade': {
                        $(target).hide().slideDown(this.option('animationDuration'))
                            .css({opacity:0})
                            .animate({opacity: 1}, this.option('animationDuration'));
                        break;
                    }
                }
                this.dispatchEvent('open', $(target));
            },

            /**
             * Stops event propagation
             * @param {type} e
             * @returns {undefined}
             */
            _stopEventPropagation: function(e){
                e.stopPropagation();
            },

            /**
             * Close target
             * @param {type} element
             * @param {type} target
             * @returns {undefined}
             */
            closeTarget: function(element, target, e){
                //Hide target
                if (typeof(e) !== 'undefined') {
                    e.stopPropagation();
                }
                $(target).removeClass(this.option('targetIsVisibleClass'));
                $(target).addClass(this.option('targetIsHiddenClass'));

                //Change classes on caller element
                $(element).addClass(this.option('elementTargetIsHiddenClass'));
                $(element).removeClass(this.option('elementTargetIsVisibleClass'));

                //Remove close handler on outside click (for tooltips, flyouts etc.)
                $(target).off('click', this._stopEventPropagation);
                $('html').off('click', $.proxy(this.closeTarget, this, element, target));


                //Change labels on caller element if enabled
                if (this.option('exchangeLabel')){
                    $(this.option('exchangeLabelSelector'), element).each(function(index, labelElement){
                        $(labelElement).text($(labelElement).attr('data-label-hidden'));
                    });
                }

                //Animate target
                var effect = $(target).attr('data-hide-effect');
                switch (effect){
                    case 'fade': {
                        $(target).hide().fadeOut(this.option('animationDuration'));
                        break;
                    }
                    case 'slide': {
                        $(target).hide().slideUp(this.option('animationDuration'));
                        break;
                    }
                    case 'slidefade': {
                        $(target).hide().css({opacity:1, display: 'inherit'})
                            .animate({opacity: 0}, this.option('animationDuration'))
                            .slideUp(this.option('animationDuration'));
                        break;
                    }
                }

                this.dispatchEvent('close', $(target));
            },



            /**
             * Internal variable to store configuration values
             */
            _options: {},

            /**
             * Adds options to the component.
             * The parameter options will overwrite the defaults
             * @param {object} defaults
             * @param {object|undefined} options
             * @returns {undefined}
             */
            addOptions: function(defaults, options){
                this._options = $.extend({}, this.getOptions(), defaults, options || {});
            },

            /**
             * Returns an object of all configuration options of the component
             * @returns {undefined|Object}
             */
            getOptions: function(){
                return this._options;
            },

            /**
             * Gets or sets option
             * @param name
             * @param value optional
             */
            option: function (name, value) {
                if (!_.isUndefined(value)) {
                    this._options[name] = value;
                }
                return this._options[name];
            }
        });

        return VisibilityControl;
    }
);



//////////////////
// WEBPACK FOOTER
// ./~/fcse-visibilitycontrol/visibilityControl.js
// module id = 71
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22